import script from "./InputsTextareaSection.vue?vue&type=script&setup=true&lang=js"
export * from "./InputsTextareaSection.vue?vue&type=script&setup=true&lang=js"

import "./InputsTextareaSection.vue?vue&type=style&index=0&id=345552c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-345552c6"]])

export default __exports__